import { TabAction, TabActions } from '../actions/transaction-tab.actions';
import { TransactionTabState } from '../state/transaction-tab.state';
export const initialTransactionTabState: TransactionTabState = {
    openedTransaction: null,
};

export function transactionTabReducer(
    state = initialTransactionTabState,
    action: TabAction
) {
    switch (action.type) {
        case TabActions.OpenTransactionTab:
            return {
                ...state,
                openedTransaction: action.transactionId,
            };
        default:
            return state;
    }
}
